import {Box, Link, Stack, Text} from "@chakra-ui/react";
import {useMemo} from "react";
import {FaApple, FaGooglePlay} from "react-icons/fa";

type DevicePlatform = "android-phone" | "iphone" | "other";

const detectDevicePlatform = (): DevicePlatform => {
    if (typeof navigator === "undefined") {
        return "other";
    }
    const ua = navigator.userAgent || "";
    if (/iphone|ipod/i.test(ua)) {
        return "iphone";
    }
    if (/android/i.test(ua) && /mobile/i.test(ua) && !/windows phone/i.test(ua)) {
        return "android-phone";
    }
    return "other";
};

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.soundspots";
const APP_STORE_URL = "https://apps.apple.com/app/id6766112877";

const PlayStoreBadge = () => (
    <Link
        href={PLAY_STORE_URL}
        isExternal
        _hover={{textDecoration: "none", opacity: 0.88}}
        display={"flex"}
        alignItems={"center"}
        gap={3}
        bg={"black"}
        color={"white"}
        px={5}
        py={3}
        borderRadius={"12px"}
        width={"100%"}
    >
        <Box as={FaGooglePlay} boxSize={5}/>
        <Box>
            <Text fontSize={"9px"} color={"rgba(255,255,255,0.6)"} letterSpacing={"0.12em"} textTransform={"uppercase"} mb={0.5}>
                Get it on
            </Text>
            <Text fontSize={"15px"} fontWeight={700} letterSpacing={"0.01em"}>
                Google Play
            </Text>
        </Box>
    </Link>
);

const AppStoreBadge = () => (
    <Link
        href={APP_STORE_URL}
        isExternal
        _hover={{textDecoration: "none", opacity: 0.88}}
        display={"flex"}
        alignItems={"center"}
        gap={3}
        bg={"black"}
        color={"white"}
        px={5}
        py={3}
        borderRadius={"12px"}
        width={"100%"}
    >
        <Box as={FaApple} boxSize={5}/>
        <Box>
            <Text fontSize={"9px"} color={"rgba(255,255,255,0.6)"} letterSpacing={"0.12em"} textTransform={"uppercase"} mb={0.5}>
                Download on the
            </Text>
            <Text fontSize={"15px"} fontWeight={700} letterSpacing={"0.01em"}>
                App Store
            </Text>
        </Box>
    </Link>
);

type Props = {
    direction?: "row" | "column"
}

const AppDownloadBadges = ({direction = "column"}: Props) => {
    const platform = useMemo(detectDevicePlatform, []);
    return (
        <Stack direction={direction} spacing={3} width={"100%"}>
            {platform !== "iphone" ? <PlayStoreBadge/> : null}
            {platform !== "android-phone" ? <AppStoreBadge/> : null}
        </Stack>
    );
}

export default AppDownloadBadges;
